import { combineReducers } from 'redux';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
    return arr2;
  }
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function combineTrackReducers(reducers) {
  var combinedReducer = combineReducers(reducers);
  combinedReducer.__RETRACK_GET_PATH_ARRAY__ = function () {
    return [];
  };
  Object.keys(reducers).forEach(function (reducerKey) {
    reducers[reducerKey].__RETRACK_GET_PATH_ARRAY__ = function () {
      return [].concat(_toConsumableArray(combinedReducer.__RETRACK_GET_PATH_ARRAY__()), [reducerKey]);
    };
  });
  return combinedReducer;
}
function getSelector(reducer) {
  return function (state) {
    if (typeof reducer.__RETRACK_GET_PATH_ARRAY__ === 'function') {
      var pathArray = reducer.__RETRACK_GET_PATH_ARRAY__();
      return pathArray.reduce(function (acc, val) {
        return acc[val];
      }, state);
    } else {
      throw new Error('a reducer that you intended to use its selector is not being tracked by `retrack`. ensure all of your reducers are being combined using `combineTrackReducers`');
    }
  };
}
var namespacingFunction = function namespacingFunction(strArr) {
  return strArr.join('/');
};
function setNamespacingFunction(customFunction) {
  namespacingFunction = customFunction;
}
function namespaceReducerActions(reducer, actionTypes) {
  var actionTypesClone = _objectSpread({}, actionTypes);
  Object.keys(actionTypesClone).forEach(function (actionType) {
    Object.defineProperty(actionTypes, actionType, {
      get: function get() {
        if (typeof reducer.__RETRACK_GET_PATH_ARRAY__ === 'function') {
          return namespacingFunction([].concat(_toConsumableArray(reducer.__RETRACK_GET_PATH_ARRAY__()), [actionTypesClone[actionType]]));
        } // before any combineTrackReducer is called on the reducer

        return {
          toString: function toString() {
            if (typeof reducer.__RETRACK_GET_PATH_ARRAY__ === 'function') {
              return namespacingFunction([].concat(_toConsumableArray(reducer.__RETRACK_GET_PATH_ARRAY__()), [actionTypesClone[actionType]]));
            }
            return actionTypesClone[actionType];
          }
        };
      },
      set: function set() {
        throw new Error('`retrack`: you are not supposed to change action types after passing to `namespaceReducerActions`.');
      }
    });
  });
}
export { combineTrackReducers, getSelector, namespaceReducerActions, setNamespacingFunction };